import { z } from 'zod'
import { Model } from './architecture'

export const ACCOMMODATION_TYPES = [
  'HOTEL',
  'RURAL',
  'HOMES',
  'HOSTEL',
  'APARTMENT',
  'RESIDENCE',
  'CAMPING',
  'INN',
  'BNB',
  'VILLA',
  'MOTEL',
  'RIAD',
  'BOTEL',
  'CRUISE',
  'SAFARI',
  'TREEHOUSE',
  'HOUSEBOAT',
  'RESORT',
  'APTHOTEL',
  'PENDING',
] as const

export type AccommodationType = (typeof ACCOMMODATION_TYPES)[number]

export const AccommodationValidation = z.object({
  value: z.enum(ACCOMMODATION_TYPES, { required_error: '[Accomodation] value is required' }),
})

export class Accommodation extends Model {
  static create({ value }: z.infer<typeof AccommodationValidation>) {
    AccommodationValidation.parse({ value })
    return new Accommodation(value)
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
